import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormControl,
  FormLabel,
  Row,
} from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FormFeedback } from 'reactstrap';
import classnames from 'classnames';

import { appName, currentYear } from '../common/helpers';
import PageMetaData from '../common/components/pageMetaData/PageMetaData';
import HorizontalLogo from '../common/components/logo/HorizontalLogo';
import { login } from '../auth/AuthActions';
import LoginSchema from '../auth/login/Login.schema';
import RouterPaths from '../constants/RouterPaths';

function LoginLayout() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const authenticate = async () => {
    setErrors({});
    try {
      await LoginSchema.validate(form, { abortEarly: false });
      dispatch(login(form.email, form.password));
    } catch (validation) {
      const validationErrors = validation.inner.reduce((acc, e) => {
        acc[e.path] = e.message;
        return acc;
      }, {});
      setErrors(validationErrors);
    }
  };

  return (
    <>
      <PageMetaData title="Login" />
      <div
        className="auth-box overflow-hidden align-items-center d-flex"
        style={{ minHeight: '100vh' }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col xxl={4} md={6} sm={8}>
              <div className="auth-brand text-center mb-4">
                <HorizontalLogo />
                <h4 className="fw-bold mt-3">Welcome to Admin Panel</h4>
                <p className="text-muted w-lg-75 mx-auto">
                  Let’s get you signed in. Enter your email and password to continue.
                </p>
              </div>

              <Card className="p-4 rounded-4">
                <Form onSubmit={(e) => e.preventDefault()}>
                  <div className="mb-3 form-group">
                    <FormLabel>
                      Email address <span className="text-danger">*</span>
                    </FormLabel>
                    <FormControl
                      type="email"
                      name="email"
                      placeholder="you@example.com"
                      value={form.email}
                      onChange={handleChange}
                      className={classnames('form-control', {
                        'is-invalid': errors.email,
                      })}
                    />
                    {errors.email && <FormFeedback>{errors.email}</FormFeedback>}
                  </div>

                  <div className="mb-3 form-group">
                    <FormLabel>
                      Password <span className="text-danger">*</span>
                    </FormLabel>
                    <FormControl
                      type="password"
                      name="password"
                      placeholder="••••••••"
                      value={form.password}
                      onChange={handleChange}
                      className={classnames('form-control', {
                        'is-invalid': errors.password,
                      })}
                    />
                    {errors.password && <FormFeedback>{errors.password}</FormFeedback>}
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <Link
                      to={RouterPaths.FORGOT_PASSWORD}
                      className="text-decoration-underline link-offset-3 text-muted"
                    >
                      Forgot Password?
                    </Link>
                  </div>

                  <Button
                    className="rounded-pill fw-semibold py-2 w-100"
                    onClick={authenticate}
                  >
                    Login
                  </Button>
                </Form>
              </Card>

              <p className="text-center text-muted mt-4 mb-0">
                © {currentYear} <span className="fw-semibold">{appName}</span>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default LoginLayout;
